import { ExpandLess, ExpandMore, CheckCircle, ReportProblem } from '@mui/icons-material'
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List,
  ListSubheader,
} from '@mui/material'
import { IntegrationNotice } from '../integrationNotice'
import { t } from '@lingui/core/macro'
import { IIntegrationItemProps, IIntegrationItemsProps } from './types'

const Item = ({ execution, isOpen, onClick, children }: IIntegrationItemProps) => {
  const inError = execution['Output Configuration Error']

  return (
    <>
      <ListItemButton
        key={execution.id}
        onClick={() => {
          onClick(execution.id)
        }}
        disableRipple={true}
      >
        <ListItemIcon sx={{ minWidth: 0, marginRight: '5px' }}>
          {inError ? <ReportProblem color="error" /> : <CheckCircle color="success" />}
        </ListItemIcon>
        <ListItemText
          primary={inError ? execution['Connector Name'] : execution['Created File']}
          primaryTypographyProps={{ sx: { fontSize: '12px', overflowWrap: 'break-word' } }}
        />
        {children}
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={isOpen}>
        {inError ? (
          <IntegrationNotice execution={execution} type="error" />
        ) : (
          <IntegrationNotice execution={execution} type="success" />
        )}
      </Collapse>
    </>
  )
}

export const IntegrationStatus = ({
  assignments,
  executions,
  children,
}: IIntegrationItemsProps) => {
  if (!assignments?.length) return null

  return assignments?.map(assignment => (
    <List
      key={assignment.id}
      subheader={
        <ListSubheader
          component="header"
          id="nested-list-subheader"
          sx={{ padding: 0, lineHeight: '1.45' }}
        >
          <strong>{t`Integration name:`}</strong> {assignment?.name}
        </ListSubheader>
      }
      sx={{ marginTop: '10px' }}
    >
      {executions[assignment.id]?.map(x => (
        <div key={x.id}>{children(x)}</div>
      ))}
    </List>
  ))
}

IntegrationStatus.Item = Item
